import { createSlice } from '@reduxjs/toolkit';
import {
  passwordResetRequestUser,
  passwordResetRequestAdmin,
  updateAdminPassword,
  updateUserPassword,
} from '~/api';

const initialState = {
  isCompleted: false,
  isReset: false,
};

/**
 * パスワードリセットの状態管理Slice。
 */
const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  // パスワードリセットリクエストAPIは必ず成功を返すので一律trueに更新する
  extraReducers: {
    [passwordResetRequestUser.fulfilled.type]: (state) => {
      return { ...state, isCompleted: true };
    },
    [passwordResetRequestAdmin.fulfilled.type]: (state) => {
      return { ...state, isCompleted: true };
    },
    [updateUserPassword.fulfilled.type]: (state) => {
      return { ...state, isReset: true };
    },
    [updateAdminPassword.fulfilled.type]: (state) => {
      return { ...state, isReset: true };
    },
  },
});

// sliceで定義したactionは全てexport
export const { initialize } = passwordResetSlice.actions;

// reducerをexportする
export default passwordResetSlice.reducer;
